/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import { useContext, useEffect } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';

const KhaltiPayment = ({ Amount }) => {

    const { BaseUrl, setPaymentLod } = useContext(MyContext);

    const handlePayment = async () => {
        
        sessionStorage.setItem("Amount", Amount);

        await axios.post(`${BaseUrl}react_khalti/index.php`,
            {
                "amt": Amount
            }
        )
            .then((res) => {
                if (res.data.Result === "true") {
                    window.location.href = res.data.payment_url;
                    setPaymentLod(false);
                }
            })
            .catch((error) => {
                console.log("react_khalti/index.php", error);
            });
    };

    useEffect(() => {
        if (!Amount) return;
        handlePayment();
    }, [Amount]);

    return null;
};

export default KhaltiPayment;
/* jshint ignore:end */